import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScrewdriver } from '@fortawesome/free-solid-svg-icons';
import { LinearProgress } from '@mui/material';
import { withRouter } from 'react-router-dom';
import {
    createDataSource, createGridOptions, DataGrid, indexCellRenderer, LinkCellRenderer, TextFilterDefaults,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { ApiRoutes } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import { MaterialForm } from './MaterialForm';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';

class MaterialIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.materialForm = React.createRef();

        this.state = {
            loading: true,
            roles: [],
            showMaterialForm: false,
        };

        this.onAddMaterial = this.onAddMaterial.bind(this);
        this.onEditMaterial = this.onEditMaterial.bind(this);
        this.onMaterialFormClosed = this.onMaterialFormClosed.bind(this);
    }

    componentDidMount() { return this.populateState(); }

    onAddMaterial = () => {
        this.materialForm.current.open();
    };

    onEditMaterial = (id) => {
        this.materialForm.current.open(id);
    };

    onMaterialFormClosed() {
        this.setState({ showMaterialForm: false });
    }

    onMaterialSaveCallback = (response) => {
        this.setState({ showMaterialForm: false });
        this.context.setFormOpened(false);
        // Refresh grid
        this.state.gridApi.setDatasource(this.state.dataSource);
    };

    async populateState() {

        // Get grid defaults and handlers
        const gridOptions = createGridOptions(this);

        // Specify any custom components, filtering
        gridOptions.components = {
            selectFilter: DataGridSelectFilter,
            selectFloatingFilter: DataGridSelectFloatingFilter,
            nameRenderer: LinkCellRenderer,
        };

        // Provide column definitions
        gridOptions.columnDefs = [
            {
                flex: 0,
                width: 75,
                headerName: '',
                valueGetter: 'node.id',
                sortable: false,
                cellRenderer: indexCellRenderer,
            },
            {
                colId: 'Number',
                sortable: true,
                headerName: 'Number',
                field: 'materialNumber',
                sort: { direction: 'asc', priority: 0 },
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                },
                cellRenderer: 'nameRenderer',
                cellRendererParams: {
                    clicked: this.onEditMaterial,
                    nameField: 'materialNumber',
                    idField: 'id',
                    title: 'View this Material',
                },
            },
            {
                colId: 'Description',
                sortable: true,
                headerName: 'Description',
                field: 'description',
                sort: { direction: 'asc', priority: 0 },
                filter: 'agTextColumnFilter',
                floatingFilter: true,
                filterParams: TextFilterDefaults,
                floatingFilterComponentParams: {
                    suppressFilterButton: true,
                }
            }
        ];

        // Create datasource.  Is reused and rebound on refresh from the state.
        const dataSource = createDataSource(ApiRoutes.material.search(), gridOptions);

        this.setState((state) => ({
            loading: false,
            gridOptions,
            dataSource,
        }));
    }

    render() {
        if (this.state.loading) return (<LinearProgress variant="indeterminate" color="secondary" />);

        const { rowData, gridOptions } = this.state;

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon icon={faScrewdriver} className="mr-2 text-muted" />
                    <span>Materials</span>
                </PageHeading>
                <DataGridToolbar
                    entity="equipmenttype"
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    onAdd={this.onAddMaterial}
                    addLabel="Add Material"
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
                <MaterialForm
                    ref={this.materialForm}
                    equipmentType={this.state.selectedMaterial}
                    onClose={this.onMaterialFormClosed}
                    show={this.state.showMaterialForm}
                    onSaveCallback={this.onMaterialSaveCallback}
                />
            </PageWrap>
        );
    }
}
export default withRouter(MaterialIndex);
